import { useGame } from '../../contexts/GameContext';
import Key from './Key';
import './Keyboard.css';

const KEYBOARD_ROWS = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'BACKSPACE']
];

function Keyboard() {
  const { state } = useGame();

  // Calculate letter statuses based on all guesses
  const getLetterStatus = (letter) => {
    let status = null;

    state.guesses.forEach((guess, guessIndex) => {
      const evaluation = state.evaluations[guessIndex];
      if (!evaluation) return; // Skip if evaluation doesn't exist

      guess.split('').forEach((char, charIndex) => {
        if (char.toUpperCase() === letter) {
          const currentEval = evaluation[charIndex];

          // Priority: correct > present > absent
          if (currentEval === 'correct') {
            status = 'correct';
          } else if (currentEval === 'present' && status !== 'correct') {
            status = 'present';
          } else if (currentEval === 'absent' && !status) {
            status = 'absent';
          }
        }
      });
    });

    return status;
  };

  const disabled = state.gameState !== 'playing';

  return (
    <div className="keyboard">
      {KEYBOARD_ROWS.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((key) => (
            <Key
              key={key}
              value={key}
              status={getLetterStatus(key)}
              disabled={disabled}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default Keyboard;